import PropTypes from "prop-types";
import React from "react";

export default class StatusBar extends React.PureComponent {

  static propTypes = {
    "daysSinceDelivery": PropTypes.number,
    "scenario": PropTypes.string.isRequired,
    "timeDelivered": PropTypes.string,
    "trackingUrl": PropTypes.string,
    "warehouseClosed": PropTypes.bool
  };

  static defaultProps = {
    "daysSinceDelivery": null,
    "timeDelivered": null,
    "trackingUrl": null,
    "warehouseClosed": false
  };

  static message (scenario, warehouseClosed) {
    switch (scenario) {
    case "in_transit":
      return "Your box is in transit";
    case "has_set":
      return "Your box was delivered:";
    case "new_member" && !warehouseClosed:
      return "Matching you with a stylist";
    case "in_curation" && !warehouseClosed:
      return "Your set is being styled";
    case "preview":
      return "Your set is ready to preview";
    case "after_preview_before_shipped":
      return "Your box is ready to ship";
    default:
      return null;
    }
  }

  static display (scenario) {
    return [
      "generic",
      "cancelled",
      "on_hold",
      "incomplete_signup"
    ].indexOf(scenario) === -1;
  }

  static trackingInfo (trackingUrl) {
    return (
      <div className="center">
        <a
          href={trackingUrl}
          target="_blank"
        >
          Track your shipment
        </a>
      </div>
    );
  }

  displayTrackingInfo () {
    const {trackingUrl, daysSinceDelivery} = this.props;
    let showTrackingInfo = null;
    if (trackingUrl && daysSinceDelivery <= 30) {
      showTrackingInfo = true;
    }
    return (
      <div>
        {showTrackingInfo
          ? this.constructor.trackingInfo(trackingUrl)
          : ""}
      </div>
    );
  }

  render () {
    const {scenario, timeDelivered, warehouseClosed} = this.props;
    const iconName = scenario === "new_member"
      ? "in_curation"
      : scenario;

    let greeting = this.constructor.message(scenario, warehouseClosed);
    if (scenario === "has_set" && timeDelivered) {
      greeting += ` ${timeDelivered}`;
    }

    return greeting && (
      <div className="greeting-bar">
        <div
          className={this.constructor.display(scenario)
            ? "color-black color-sunshine-1-bg"
            : "tmp-hidden"}
        >
          <div
            className="mt0 center desktop-only greeting"
          >
            { iconName &&
              <img
                className="mr8"
                height="20px"
                role="presentation"
                src={`assets/roxy/homepage/new_lihp/icons/${iconName}.svg`}
              />
            }
            {greeting}
            {this.displayTrackingInfo()}
          </div>
          <div
            className="mt0 center mobile-only greeting"
          >
            { iconName &&
              <img
                className="mr8"
                height="20px"
                role="presentation"
                src={`assets/roxy/homepage/new_lihp/icons/${iconName}.svg`}
              />
            }
            {greeting}
          </div>
        </div>
      </div>
    );
  }
}
